var __jsx = React.createElement;
import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import { connect } from 'react-redux';
import { Wrapper } from './styles';
import { MapIcon } from '@spa/shared/svg';
import Chip from '@spa/shared/components/Unisystem/Chip';
import { MediaContext } from '@spa/shared/contexts/media';
import { showModalAction } from '@spa/shared/store/actions/modal';
import { modalIds } from '@spa/offer/components/Modals/modal-displayer';
import { trackMapOpened, trackFloorPlanOpened, trackVideoOpened } from '@spa/offer/store/actions/tracking';
import FloorPlan from '@spa/shared/svg/floor-plan';
import YoutubeAlternative from '@spa/shared/svg/youtube-alternative';
import { PHOTOS_MODAL_SECTIONS } from '@spa/offer/constants/modals';
var GalleryButtons = function GalleryButtons(_ref) {
  var hasFloorPlan = _ref.hasFloorPlan,
    hasVideo = _ref.hasVideo,
    showMap = _ref.showMap,
    showGallery = _ref.showGallery;
  var _useContext = useContext(MediaContext),
    is = _useContext.is;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var showFloorPlan = function showFloorPlan() {
    return showGallery(PHOTOS_MODAL_SECTIONS.floor_plan.label);
  };
  var showVideo = function showVideo() {
    return showGallery(PHOTOS_MODAL_SECTIONS.video.label);
  };
  return __jsx(Wrapper, {
    isMobile: is.mobile
  }, __jsx(Chip, {
    isPrimary: true,
    label: t('Map'),
    icon: MapIcon,
    onClick: showMap
  }), hasFloorPlan && __jsx(Chip, {
    className: 'floor-plan',
    isPrimary: true,
    label: t('Floor plan'),
    icon: FloorPlan,
    onClick: showFloorPlan
  }), hasVideo && __jsx(Chip, {
    className: 'video',
    isPrimary: true,
    label: t('Video'),
    icon: YoutubeAlternative,
    onClick: showVideo
  }));
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var offerAggregate = _ref2.offer.offerAggregate;
  var _offerAggregate$accom = offerAggregate.accommodation_offer;
  _offerAggregate$accom = _offerAggregate$accom === void 0 ? {} : _offerAggregate$accom;
  var _offerAggregate$accom2 = _offerAggregate$accom.floor_plan;
  _offerAggregate$accom2 = _offerAggregate$accom2 === void 0 ? {} : _offerAggregate$accom2;
  var floorPlanName = _offerAggregate$accom2.name,
    _offerAggregate$prope = offerAggregate.property_aggregate.property;
  _offerAggregate$prope = _offerAggregate$prope === void 0 ? {} : _offerAggregate$prope;
  var video = _offerAggregate$prope.video;
  return {
    hasFloorPlan: !!floorPlanName,
    hasVideo: !!(video !== null && video !== void 0 && video.url)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showMap: function showMap() {
      dispatch(trackMapOpened());
      dispatch(showModalAction({
        modalId: modalIds.MAP
      }));
    },
    showGallery: function showGallery(section) {
      section === PHOTOS_MODAL_SECTIONS.floor_plan.label ? dispatch(trackFloorPlanOpened()) : dispatch(trackVideoOpened());
      dispatch(showModalAction({
        modalId: modalIds.PHOTOS_MODAL,
        section: section
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(GalleryButtons);